module.exports = __webpack_public_path__ + "static/img/delegation_empty.6a258f1e.png";